module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-500italic.woff2?0d8bb5b3ee5f5dac9e446d48480d28a9";